import React from "react";
import SiteHeader from "./home/SiteHeader";
import Intro from "./home/Intro";
import Projects from "./home/Projects";
import Team from "./home/Team";
import Contact from "./home/Contact";
import SiteFooter from "./home/SiteFooter";
import "../styles/home.css";
// Temporarily disabled — re-enable when ready:
// import Statement from "./home/Statement";
// import Approach from "./home/Approach";

// The intro is a tall, sticky black stage: scrolling composes the mark
// stroke-by-stroke, then the wordmark and tagline rise. The work index, team
// and contact follow in normal flow over a faint grid.
export default function HomePage() {
  return (
    <div className="dp" id="top">
      <SiteHeader />

      <Intro />

      <main className="dp-body">
        <Projects />

        <Team />

        {/* Studio & Approach are temporarily disabled — re-enable when ready:
        <Statement />
        <Approach />
        */}

        <Contact />
      </main>

      <SiteFooter />
      <div className="dp-grain" aria-hidden="true" />
    </div>
  );
}
